module.exports = __webpack_public_path__ + "img/292.1b284b25.png";